import { FormationContinueType as FormationContinueTypeGql } from '@graphql/generated';
import { FormationContinueType as FormationContinueTypeModel } from '@lib/models/formation-continue/formation-continue.model';

export class FormationContinueMapper {
  public static parseHours(value: unknown): number | undefined {
    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : undefined;
    }

    if (typeof value !== 'string') return undefined;

    const hours = Number(value.trim().replace(',', '.'));
    return Number.isFinite(hours) ? hours : undefined;
  }

  public static fromGraphQl(
    formationType: FormationContinueTypeGql
  ): FormationContinueTypeModel {
    const mapping: Record<FormationContinueTypeGql, FormationContinueTypeModel> = {
      [FormationContinueTypeGql.Immobilier]: 'IMMOBILIER',
      [FormationContinueTypeGql.Mia]: 'MIA',
      [FormationContinueTypeGql.IobSansStefi]: 'IOB_SANS_STEFI',
      [FormationContinueTypeGql.IobStefiCreditImmo]: 'IOB_STEFI_CREDIT_IMMO',
      [FormationContinueTypeGql.IobStefiCreditConso]: 'IOB_STEFI_CREDIT_CONSO',
      [FormationContinueTypeGql.IobStefiRegroupementCredit]:
        'IOB_STEFI_REGROUPEMENT_CREDIT',
    };
    return mapping[formationType];
  }

  public static toGraphQl(
    formationType: FormationContinueTypeModel
  ): FormationContinueTypeGql {
    const mapping: Record<FormationContinueTypeModel, FormationContinueTypeGql> = {
      IMMOBILIER: FormationContinueTypeGql.Immobilier,
      MIA: FormationContinueTypeGql.Mia,
      IOB_SANS_STEFI: FormationContinueTypeGql.IobSansStefi,
      IOB_STEFI_CREDIT_IMMO: FormationContinueTypeGql.IobStefiCreditImmo,
      IOB_STEFI_CREDIT_CONSO: FormationContinueTypeGql.IobStefiCreditConso,
      IOB_STEFI_REGROUPEMENT_CREDIT: FormationContinueTypeGql.IobStefiRegroupementCredit,
    };
    return mapping[formationType];
  }
}
